<template>
  <div class="profile-bg">
    <div class="profile-card">
      <div class="profile-btn-tabs">
        <button
          :class="['tab-btn', activeTab === 'basic-info' ? 'active' : '']"
          @click="handleTabChange('basic-info')"
        >基本信息</button>
        <button
          :class="['tab-btn', activeTab === 'change-password' ? 'active' : '']"
          @click="handleTabChange('change-password')"
        >修改密码</button>
      </div>
      <div class="content">
        <div v-if="activeTab === 'basic-info'">
          <el-form :model="basicInfo" :rules="basicInfoRules" ref="basicInfoForm" label-width="100px">
            <el-form-item label="账号">
              <el-input v-model="basicInfo.accountNumber" disabled></el-input>
            </el-form-item>
            <el-form-item label="所属教师ID">
              <el-input v-model="basicInfo.teachID" disabled></el-input>
            </el-form-item>
            <el-form-item label="用户名" prop="userName" required>
              <template #label>
                <span class="required-star">*</span>用户名
              </template>
              <el-input v-model="basicInfo.userName"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone" required>
              <template #label>
                <span class="required-star">*</span>手机号
              </template>
              <el-input v-model="basicInfo.phone"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email" required>
              <template #label>
                <span class="required-star">*</span>邮箱
              </template>
              <el-input v-model="basicInfo.email"></el-input>
            </el-form-item>
            <el-form-item>
              <div class="btn-group">
                <el-button type="primary" @click="saveBasicInfo">保存</el-button>
                <el-button @click="resetBasicInfo" plain>取消</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div v-else-if="activeTab === 'change-password'">
          <el-form :model="passwordInfo" :rules="passwordRules" ref="passwordForm" label-width="100px">
            <el-form-item label="账号">
              <el-input v-model="passwordInfo.accountNumber" disabled></el-input>
            </el-form-item>
            <el-form-item label="旧密码" prop="oldPassword" required>
              <template #label>
                <span class="required-star">*</span>旧密码
              </template>
              <el-input type="password" v-model="passwordInfo.oldPassword"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword" required>
              <template #label>
                <span class="required-star">*</span>新密码
              </template>
              <el-input type="password" v-model="passwordInfo.newPassword"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword" required>
              <template #label>
                <span class="required-star">*</span>确认密码
              </template>
              <el-input type="password" v-model="passwordInfo.confirmPassword"></el-input>
            </el-form-item>
            <el-form-item>
              <div class="btn-group">
                <el-button type="primary" @click="savePassword">保存</el-button>
                <el-button @click="resetPassword" plain>取消</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { EventBus } from '@/event-bus.js';
export default {
  name: 'Profile',
  data() {
    return {
      activeTab: 'basic-info',
      basicInfo: {
        accountNumber: '',
        userName: '',
        phone: '',
        email: '',
        createTime: [], // 存储创建时间
        teachID:'',
      },
      basicInfoRules: {
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' },
        ],
      },
      passwordInfo: {
        accountNumber: '',
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      passwordRules: {
        oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        confirmPassword: [
          {
            required: true,
            message: '请确认新密码',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (value !== this.passwordInfo.newPassword) {
                callback(new Error('两次输入的密码不一致'));
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.fetchUserInfo();
  },
  methods: {
    async fetchUserInfo() {
      const accountNumber = localStorage.getItem('userInfo');
      if (accountNumber) {
        try {
          const { data } = await axios.get(
            `/api/auth/selectByAccountNumber?accountNumber=${accountNumber.replace(/^"|"$/g, '')}`
          );
          // console.log(data.data);
          
          if (data.code === 0 && data.data) {
            this.basicInfo = data.data;
            this.passwordInfo.accountNumber = data.data.accountNumber;
            this.basicInfo.createTime = data.data.createTime;
            this.basicInfo.teachID=data.data.teacherId 
          } else {
            console.error('用户信息加载失败:', data.msg);
          }
        } catch (error) {
          console.error('请求用户信息时出错:', error);
        }
      }
    },

    saveBasicInfo() {
      this.$refs.basicInfoForm.validate(async (valid) => {
        if (valid) {
          const createTime = new Date(...this.basicInfo.createTime);
          const now = new Date();
          const diffInDays = Math.floor((now - createTime) / (1000 * 60 * 60 * 24));

          if (diffInDays < 30) {
            this.$message.error('距离上次修改不足30天，无法修改');
            return;
          }

          this.$confirm('确认保存修改吗？', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              try {
                const response = await axios.post('/api/auth/updateUser', {
                  accountNumber: this.basicInfo.accountNumber,
                  userName: this.basicInfo.userName,
                  phone: this.basicInfo.phone,
                  email: this.basicInfo.email,
                  createTime: [now.getFullYear(), now.getMonth() + 1, now.getDate(),now.getHours(), now.getMinutes()],
                });

                if (response.data.code === 0) {
                  this.$message.success('保存成功');
                  // 通过事件总线通知用户名更新
        EventBus.$emit('userNameUpdated');
                } else {
                  this.$message.error(`保存失败: ${response.data.msg}`);
                }
              } catch (error) {
                console.error('保存时出错:', error);
                this.$message.error('保存失败，请稍后重试');
              }
            })
            .catch(() => {
              this.$message.info('已取消保存');
            });
        }
      });
    },

    resetBasicInfo() {
      this.$refs.basicInfoForm.resetFields();
      this.fetchUserInfo();
    },

    savePassword() {
  this.$refs.passwordForm.validate(async (valid) => {
    if (valid) {
      try {
        // 发起 POST 请求，传输新旧密码和账号
        const response = await axios.post('/api/auth/updatePassword', {
          accountNumber: this.passwordInfo.accountNumber,
          oldPassword: this.passwordInfo.oldPassword,
          newPassword: this.passwordInfo.newPassword,
        });

        // 判断接口返回状态
        if (response.data.code === 0) {
          this.$message.success('密码修改成功');
          this.resetPassword(); // 重置表单
          this.$router.push('/login');
        } else {
          this.$message.error(`修改失败: ${response.data.msg}`);
        }
      } catch (error) {
        console.error('修改密码时出错:', error);
        this.$message.error('修改失败，请稍后重试');
      }
    }
  });
},
    resetPassword() {
      this.$refs.passwordForm.resetFields();
    },

    handleTabChange(index) {
      this.activeTab = index;
      this.$nextTick(() => {
        if (index === 'change-password' && this.$refs.passwordForm) {
          this.$refs.passwordForm.resetFields();
        }
        if (index === 'basic-info' && this.$refs.basicInfoForm) {
          this.$refs.basicInfoForm.resetFields();
        }
      });
    },
  },
};
</script>

<style scoped>
.profile-bg {
  min-height: 100vh;
  background: #eaf6fe;
  display: flex;
  align-items: center;
  justify-content: center;
}
.profile-card {
  background: #fff;
  border-radius: 16px;
  padding: 40px 32px 32px 32px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);
  width: 90%;
  height: 700px;
  margin-bottom: 80px;
}
.profile-btn-tabs {
  display: flex;
  gap: 24px;
  margin-bottom: 50px;
}
.tab-btn {
  min-width: 120px;
  padding: 10px 24px;
  border: 1px solid #2EA2FA;
  background: #fff;
  color: #2EA2FA;
  font-size: 16px;
  border-radius: 8px;
  cursor: pointer;
  outline: none;
  transition: all 0.2s;
  
}
.tab-btn.active {
  background: #2EA2FA;
  color: #fff;
  box-shadow: 2px 2px 10px  rgba(46, 162, 250, 1);
}
.tab-btn:not(.active):hover {
  border-color: #2EA2FA;
  color: #2EA2FA;
}
.required-star {
  color: #f56c6c;
  margin-right: 2px;
}
.btn-group {
  display: flex;
  justify-content: center;
  gap: 24px;
}
.el-form-item {
  margin-bottom: 60px;
}
</style>
